<ng-container *transloco="let t">
  <div>
    <label class="font-weight-bold">{{t('input-stopwatch-report.totalDuration')}}:</label><span> {{totalDuration$ |
      async}}</span>
  </div>

  <table>
    <thead>
      <tr>
        <th><label class="font-weight-bold">{{t('input-stopwatch-report.time')}}</label></th>
        <th><label class="font-weight-bold">{{t('input-stopwatch-report.type')}}</label></th>
        <th><label class="font-weight-bold">{{t('input-stopwatch-report.partial')}}</label></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let v of values$ | async">
        <td>
          <span>{{v.timestamp | date: 'dd/MM/yyyy HH:mm:ss'}}</span>
        </td>
        <td>
          <span class="text-uppercase">{{$any(v.value).type}}</span>
        </td>
        <td>
          <span>{{$any(v.value).durationFromStepStart | msToTime}}</span>
        </td>
      </tr>
    </tbody>
  </table>

</ng-container>
